// Module
var code = "<div class=\"bg-white\" layout=\"column\" layout-fill> <div class=\"abx-logo-header\"><img src=\"img/logo.png\" width=\"200\"/></div> <div flex layout=\"column\" ui-view></div> </div> ";
// Exports
module.exports = code;